import { useEffect } from 'react'
import type { ReactNode } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router'
import {
  AnimatedCheckMark,
  getTaskTitle,
  LinkExternal,
  TopBar,
  AppLayout,
  useGetSampleByIdQuery,
  useGetTaskByIdQuery,
  Mtds,
  MapWithMarker,
  NoPosFoundError,
  geometryToLongitudeLatitude
} from 'prove-common'
import { diff } from 'deep-object-diff'
import { AppLogo } from '../components/app-logo/AppLogo'

export const SampleEditCompletedScreen = () => {
  const { sampleId } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const {
    data: sample,
    isPending: isPendingSample,
    isError: isErrorSample
  } = useGetSampleByIdQuery(sampleId)
  const {
    data: task,
    isPending: isPendingTask,
    isError: isErrorTask
  } = useGetTaskByIdQuery(sample?.taskId)
  const isPending = isPendingSample || isPendingTask
  const isError = isErrorSample || isErrorTask
  const lonLat = sample
    ? geometryToLongitudeLatitude(sample.geometry)
    : undefined
  const diffSample =
    sample == null ? {} : diff(location.state?.oldSample, sample)
  useEffect(() => {
    if ('vibrate' in navigator) {
      const pattern = [200, 100, 200, 100, 200, 100, 200]
      navigator.vibrate(pattern)
    }
  }, [])

  const breadcrumbItems = [
    {
      label: 'Prøver',
      to: '/samples'
    },
    {
      label: '#' + sampleId,
      to: `/samples/${sampleId}`
    },
    {
      label: 'Redigert'
    }
  ]

  let locationDisplay: ReactNode = null
  if (task?.locationRequired && lonLat) {
    locationDisplay = (
      <MapWithMarker latitude={lonLat.latitude} longitude={lonLat.longitude} />
    )
  } else if (task?.locationRequired) {
    locationDisplay = <NoPosFoundError />
  }

  return (
    <AppLayout
      isLoading={isPending}
      isError={isError}
      topBar={<TopBar logo={<AppLogo />} breadcrumbItems={breadcrumbItems} />}
      contentLayout='none'
    >
      <Mtds.Grid data-align='center' data-gap={12} className='h-full'>
        <Mtds.Grid data-justify='center' data-gap={12} data-color='success'>
          <AnimatedCheckMark />
          <Mtds.Prose data-justify='center'>
            <Mtds.Heading as='h1' data-size='lg' data-justify='center'>
              Prøve redigert
            </Mtds.Heading>
            <p>
              Prøve{' '}
              {
                <LinkExternal
                  to={'/samples/' + sample?.id}
                  text={sample?.id ?? '-'}
                ></LinkExternal>
              }{' '}
              er registrert på{' '}
              {
                <LinkExternal
                  to={'/tasks/' + task?.id}
                  text={getTaskTitle(task)}
                ></LinkExternal>
              }
            </p>
          </Mtds.Prose>
        </Mtds.Grid>
        {locationDisplay}
        <Mtds.Button
          data-arrow={'left'}
          data-variant={'primary'}
          onClick={() =>
            navigate('/samples/' + sample?.id, {
              state: {
                diffSample,
                oldSample: location.state?.oldSample
              }
            })
          }
        >
          Tilbake til prøve
        </Mtds.Button>
      </Mtds.Grid>
    </AppLayout>
  )
}
